const initialState = {
	main: {
		uri: null,
		uriCrop: null,
		uriCropBlur: null,
		id: null,
	},
	mainRestriction: 0,
	sub: [],
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_PHOTO_SET') {
		let newState = Object.assign([], state);
		newState.main.uri = action.payload.main.uri;
		newState.main.uriCrop = action.payload.main.uriCrop;
		newState.main.uriCropBlur = action.payload.main.uriCropBlur;
		newState.main.id = action.payload.main.id;
		newState.mainRestriction= action.payload.mainRestriction;
		newState.sub = action.payload.sub;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'MY_PHOTO_MAIN_RESTRICTION_SET') {
		let stateNew = Object.assign({}, state);

		stateNew.userdata_img_restriction = action.payload.restriction;
		return stateNew;
	}

	else {
		return state;
	}
}
